module.exports = __webpack_public_path__ + "static/sm_img03@2x-d3472755a5725f7b80e86f8ee748d39a.jpg";